<template>
  <div class="p-4 grid gap-4">
    <div>
      <ml-input class="w-full" icon-pack="feather" icon="icon-search" placeholder="현장 검색" v-model="keyword"/>
    </div>

    <!-- 카드형식 리스트-->
    <div v-for="item in fields" class="px-4 py-8  rounded-lg" :class="[item.disabled ? 'shadow-drop' : 'shadow-md cursor-pointer']" @click="clickItem(item)">
      <h4 class="font-bold" style="font-size: 1.2rem;" :style="{ color: item.disabled ? '#999999' : '#303030'}">{{ item.field_name }}</h4>
      <div class="mt-2" :style="{ color: item.disabled ? '#999999' : ''}">{{ item.address }}</div>
      <div class="mt-4" style="font-weight: 600" :style="{ color: item.disabled ? '#999999' : ''}">현장소장: {{ item.manager_name }}</div>
    </div>

    <div v-if="fieldList.length === 0" class="text-center text-gray-500">
      <p style="font-size: 1.2rem">{{ $t('선택 가능한 현장이 없습니다.') }}</p>
    </div>
  </div>
</template>

<script>
import * as UiUtil from "@/util/UiUtil";

export default {
  name: 'QrScanField',
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    fields() {
      return this.fieldList.filter((item) => {
        if (this.keyword) {
          const normalizedField = `${item.field_name}`.toLowerCase().replace(/\s+/g, '');
          const normalizedKeyword = this.keyword.toLowerCase().replace(/\s+/g, '');
          return normalizedField.indexOf(normalizedKeyword) > -1;
        }
        return item;
      })
    }
  },
  data() {
    return {
      fieldList: [],
      keyword: '',
    };
  },
  methods: {
    async loadField () {
      const fieldList = [];
      await this.__loadField(fieldList, 1, 10)
      this.fieldList = fieldList;

      console.log("fieldList", this.fieldList)
    },
    async __loadField(fieldList, page, perPage) {
      const list = await this.$store.dispatch("project/LOAD_FIELD_LIST", {
        page,
        perPage,
        projectId: this.projectId,
      });
      if (list.data.length > 0) {
        fieldList.push(...list.data);
      }

      if (list.lastPage > page) {
        await this.__loadField(fieldList, page + 1, perPage);
      }
    },

    clickItem (item) {
      this.$emit("click", item)
    }
  }
}
</script>

<style scoped lang="scss">

</style>
